import React from 'react';

import Tag from './AbstractTag';

Tag.parser.registerTag(
  'h2',
  class extends Tag {
    constructor(renderer, settings = {}) {
      super(renderer, settings);

      this.STRIP_OUTER = true;
    }

    toReact() {
      return <h2>{this.getComponents()}</h2>;
    }
  }
);
